import {
  APKS_REQ_INSTALL_START,
  APKS_REQ_INSTALL_LIST_START,
  APKS_REQ_RUN_START,
} from '../constants/anative';

export const installAndroidSoftList = softList => ({
  type: APKS_REQ_INSTALL_LIST_START,
  softList,
});

export const installAndroidSoft = soft => ({
  type: APKS_REQ_INSTALL_START,
  soft,
});

export const startAndroidSoft = soft => ({
  type: APKS_REQ_RUN_START,
  soft,
});

